<template>
  <div class="vehicle-income">
    <div class="filter-bar" style="margin-bottom: 16px; display: flex; gap: 12px; align-items: center;">
      <el-date-picker
        v-model="timeRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        value-format="timestamp"
        @change="loadData"
      />
    </div>

    <el-row :gutter="16" style="margin-bottom: 24px;">
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-label">总订单数</div>
          <div class="stat-value">{{ summary.orderCount || 0 }}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-label">实收总金额</div>
          <div class="stat-value util-money">¥{{ formatMoney(summary.totalRealFee) }}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-label">司机总收入</div>
          <div class="stat-value util-money">¥{{ formatMoney(summary.totalDriverIncome) }}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-label">平台总收入</div>
          <div class="stat-value util-money">¥{{ formatMoney(summary.totalCompanyIncome) }}</div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-label">总载客人数</div>
          <div class="stat-value">{{ summary.totalPassengerNum || 0 }} 人</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'vehicleIncome',
  props: {
    vehicleId: { type: [Number, String], required: true }
  },
  data() {
    return {
      loading: false,
      timeRange: [],
      summary: {}
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      if (!this.vehicleId) return
      this.loading = true
      const params = {
        appKey: this.$store.getters.userInfo && this.$store.getters.userInfo.appKey
      }
      if (this.timeRange && this.timeRange.length === 2) {
        params.startTime = this.timeRange[0]
        params.endTime = this.timeRange[1]
      }
      const { code, data } = await this.$axios.get('/api/v1/manage/vehicle/' + this.vehicleId + '/income', { params })
      if (code === 1) {
        this.summary = data || {}
      }
      this.loading = false
    },
    formatMoney(val) {
      return val ? Number(val).toFixed(2) : '0.00'
    }
  }
}
</script>

<style scoped lang="less">
.stat-card {
  background: #f5f7fa;
  border-radius: 8px;
  padding: 16px 20px;
  text-align: center;
  .stat-label {
    font-size: 13px;
    color: #999;
    margin-bottom: 8px;
  }
  .stat-value {
    font-size: 22px;
    font-weight: 600;
    color: #333;
  }
}
</style>
